import RouteName from '@/models/enums/RouteName'
import store from '@/store'

// ВРЕМЕННО: филиал вне VUE_APP_SUPPORT_BRANCH_IDS - на главную (support/enabled). Снять вместе с флагом.
const requireSupportEnabled = (to, from, next) => (store.getters['support/enabled'] ? next() : next('/'))

// FAKT Support (T09): без meta.permissions - поддержка есть у любого сотрудника филиала, доступ к
// обращениям проверяет сервис поддержки по филиалам из CRM.
export default [
  {
    path: '/support',
    name: RouteName.SupportAppeals,
    component: () => import('@/pages/Support/Appeals.vue'),
    beforeEnter: requireSupportEnabled,
    meta: { breadcrumb: { label: 'Обращения филиала', parent: 'Главная' } },
  },
  {
    // id - uuid обращения, не видимый номер: так его принимает API поддержки.
    path: '/support/:id',
    name: RouteName.SupportAppeal,
    component: () => import('@/pages/Support/Appeal.vue'),
    props: true,
    beforeEnter: requireSupportEnabled,
    meta: { breadcrumb: { label: 'Обращение', parent: RouteName.SupportAppeals } },
  },
]
